import { useState, useEffect } from "react";
import AnimatedText from "../../AnimatedText";
import { getB2B } from "../../api/api"; // <-- your API call
// import "./FAQsPageElementsCss/FAQsMainSection.css"; // reuse existing CSS

import '../../PageElements/FAQsPageElements/FAQsPageElementsCss/FAQsMainSection.css'
import CustomLoader from "../../common/loader/CustomLoader";

export default function B2BMainSection() {
  const [activeTab, setActiveTab] = useState(null);
  const [b2bCategory, setB2bCategory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchB2BData();
  }, []);

  const fetchB2BData = async () => {
    try {
      setLoading(true);
      const res = await getB2B();
      if (res?.data?.message === "success") {
        const apiData = res?.data?.data || [];
        if (apiData.length > 0) {
          setB2bCategory(apiData);
          setActiveTab(apiData[0].B2BId); // first tab active
          setMessage("");
        } else {
          setB2bCategory([]);
          setMessage("No data found");
        }
      } else {
        setMessage("Problem on API");
        setB2bCategory([]);
      }
    } catch (error) {
      console.error("Error fetching B2B:", error);
      setMessage("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const activeData = b2bCategory.find((item) => item.B2BId === activeTab);

  return (
    <div className="faqMainContainer">
      <div className="ourPackageUpperSection">
        <AnimatedText
          tag="h2"
          type="words"
          y={30}
          className="rb-title ourpackageTitle"
        >
          B2B
        </AnimatedText>
        <div className="textParaSection">
          <p className="paraText faqPara">
            RB Diagnostic collaborates with corporates, franchisees,
            institutions, and partners to deliver specialized healthcare
            solutions.
          </p>
        </div>
      </div>
        {loading && <CustomLoader/> }

      {/* Desktop Buttons */}
      <div className="midNavButtons desktop-only">
        {b2bCategory.map((b2b) => (
          <button
            key={b2b.B2BId}
            className={`navBtn ${activeTab === b2b.B2BId ? "active" : ""}`}
            onClick={() => setActiveTab(b2b.B2BId)}
          >
            {b2b.B2BName}
          </button>
        ))}
      </div>

      {/* Mobile Dropdown */}
      <div className="mobileDropdownContainer mobile-only">
        <select
          className="faqDropdown"
          value={activeTab || ""}
          onChange={(e) => setActiveTab(Number(e.target.value))}
        >
          {b2bCategory.map((b2b) => (
            <option key={b2b.B2BId} value={b2b.B2BId}>
              {b2b.B2BName}
            </option>
          ))}
        </select>
      </div>

      {/* <h3 className="faqHeading">B2B Info</h3> */}

      <h3 className="faqHeading">
  {activeData ? activeData.B2BName : "B2B Information"}
</h3>




      <div className="faqGrid singleItemCenter">
        <div className="faqColumn">
          {loading ? (
            <p className="text-center">Loading...</p>
          ) : message ? (
            <p className="text-center">{message}</p>
          ) : activeData ? (
            <div className="faqItem open">
              {/* <div className="faqQuestion">
                <span>{activeData.B2BName}</span>
              </div> */}
              <div
                className="faqAnswer"
                dangerouslySetInnerHTML={{ __html: activeData.B2BDesc }}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
